import { useAllSessions, useSessionTree } from '@services/session'
import { Select, SelectProps } from '@shared/Form/Select'
import { useTranslation } from 'react-i18next'

type Props = SelectProps & {
  parentId?: number
  flattenAllParkingLots?: boolean
}

export const ParkingLotAutoCompleteSelect = (props: Props) => {
  const { t } = useTranslation()

  const { parentId, flattenAllParkingLots, ...others } = props

  const { byId, loading } = useSessionTree()

  const { dataSource } = useAllSessions()

  return (
    <Select
      loading={loading}
      showSearch
      filterOption={(input, option) => {
        return (
          typeof option?.children === 'string' &&
          (option.children as string).includes(input)
        )
      }}
      {...others}>
      {!!parentId
        ? byId[parentId]?.children.map((x: any) => (
            <Select.Option key={x.id} value={x.id}>
              {x.name}
            </Select.Option>
          ))
        : flattenAllParkingLots
        ? dataSource?.content
            ?.filter(s => s.sourceType === 'parkingLot')
            .map((s: any) => (
              <Select.Option key={s.id} value={s.id}>
                {s.name}
              </Select.Option>
            ))
        : null}
    </Select>
  )
}

export default ParkingLotAutoCompleteSelect
